"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorToString = void 0;
var MortgageCommonError_1 = require("@/pages/mortagage/states/MortgageCommonError");
var format_1 = require("@/utils/format");
exports.errorToString = function (error, t, inputs) {
    if (inputs === void 0) { inputs = null; }
    if (error instanceof MortgageCommonError_1.MortgageTooMuchLoanPercentError) {
        if (inputs && inputs.propertyValue && inputs.downPayment) {
            return format_1.default.print(t.errorTooMuchLoanAmount, ["" + format_1.default.comma(Math.round(inputs.propertyValue * error.maxLoanPercent / 100))]);
        }
        return format_1.default.print(t.errorTooMuchLoanPercent, ["" + error.maxLoanPercent]);
    }
    if (error instanceof MortgageCommonError_1.MortgageTooMuchLoanAmountError) {
        if (inputs && inputs.propertyValue && inputs.downPayment) {
            return format_1.default.print(t.errorTooMuchLoanAmount, ["" + format_1.default.comma(error.maxLoanAmount)]);
        }
        return format_1.default.print(t.errorTooMuchLoanAmount, ["" + format_1.default.comma(error.maxLoanAmount)]);
    }
    if (error instanceof MortgageCommonError_1.MortgageExceedTenorError) {
        return format_1.default.print(t.errorExceedTenor, ["" + error.maxTenor]);
    }
    return t.errorUnknown;
    ;
};
